<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" borderTop />
  <MensagemIpi v-else-if="regra == 0" :titulo="titulo" :classe="nomeImposto" />
  <MensagemIcmsInterno v-else-if="icmsAliquota == null" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">ICMS ST</h2>
    <QuadroAlerta
      v-if="imposto.perguntas.length != 0"
      :classe="nomeImposto"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :borderTop="imposto.perguntas.length == 0 || !exibeAlerta"
      :titulo="imposto.nome"
      :classe="imposto.classe"
    >
      <div v-if="imposto.perguntas.length == 0">
        <ImpostoSemResultado :titulo="imposto.nome" />
      </div>
      <div v-else>
        <PerguntasIcmsSt
          :key="getRenderKey"
          :imposto="imposto"
          :edita="edita"
          :segmentoSelecionado="segmentoSelecionado"
          :seleciona="seleciona"
          :selecionouSegmento="selecionouSegmento"
          :loading="loading"
        />
      </div>
    </QuadroPrincipal>
    <div v-if="selecionouSegmento && segmentoSelecionado.id_imposto != 100">
      <QuadroIcms
        v-if="regrasQuadroIcms"
        :id="id"
        :imposto="imposto"
        :edita="editaIcms"
        :seleciona="selecionaIcms"
        :selecionado="icmsSelecionado"
        :selecionouIcms="selecionouIcms"
        :loading="loading"
        :reduzAliquota="reduzAliquota"
        :classe="nomeImposto"
      />
      <FundoIcms
        v-if="!!imposto.fundo.dados.length && !ativarLoadingSecundario && selecionouIcms"
        :classe="imposto.classe"
        :fundo="imposto.fundo"
        :seleciona="selecionaFundo"
        :fundoSelecionado="fundoSelecionado"
        :selecionouFundo="selecionouFundo"
        :edita="editaFundo"
        :loading="loading"
        :aliquotaEfetivaSelecionada="aliquotaEfetivaSelecionada"
      />
      <QuadroComplementoIcms
        v-if="regraComplemento"
        :classe="imposto.classe"
        :nome="imposto.nome"
        :complemento="imposto.complementoAliquota"
        :seleciona="selecionaComplemento"
        :complementoSelecionado="complementoSelecionado"
        :selecionouComplemento="selecionouComplemento"
        :edita="editaComplemento"
        :cargaEfetivaTributaria="cargaEfetivaTributaria"
        :loading="loading"
      />
      <BeneficiosIcms
        v-if="
          (!!imposto.beneficios.length || alteracaoImportacao) &&
            selecionouIcms &&
            !ativarLoadingTerciario &&
            icmsSelecionado.label != 'Não Incidência'
        "
        :key="forceRerenderKeyBeneficios"
        :beneficios="imposto.beneficios"
        :beneficioSelecionado="beneficioSelecionado"
        :classe="imposto.classe"
        :seleciona="selecionaBeneficio"
        :selecionouBeneficio="selecionouBeneficio"
        :loading="loading"
      />
      <ResultadoSt
        v-if="resultadoSt && !ativarLoadingQuaternario && !ativarLoadingSecundario"
        :dados="resultadoSt"
        :seleciona="selecionaSt"
        :edita="editaSt"
        :selecionouSt="selecionouSt"
        :stSelecionado="stSelecionado"
        :loading="loading"
        :mvaSelecionado="mvaSelecionado"
        :selecionouMva="selecionouMva"
        :selecionaMva="selecionaMva"
        :editaMva="editaMva"
      />
      <LoadingResultado v-if="loading" :titulo="''" :classe="nomeImposto" />
    </div>
  </div>
</template>

<script>
import rotaBufferMixin from "@/mixins/rotaBufferMixin";
import stringFormatMixin from "@/mixins/stringFormatMixin";

import BeneficiosIcms from "@/components/BeneficiosIcms/BeneficiosIcms.vue";
import FundoIcms from "@/components/FundoIcms/FundoIcms.vue";
import ImpostoSemResultado from "@/components/ImpostoSemResultado/ImpostoSemResultado.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import MensagemIcmsInterno from "@/components/MensagemIcmsInterno/MensagemIcmsInterno.vue";
import MensagemIpi from "@/components/MensagemIpi/MensagemIpi.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import PerguntasIcmsSt from "@/components/PerguntasIcmsSt/PerguntasIcmsSt.vue";
import QuadroAlerta from "@/components/QuadroAlerta/QuadroAlerta.vue";
import QuadroComplementoIcms from "@/components/QuadroComplementoIcms/QuadroComplementoIcms.vue";
import QuadroIcms from "@/components/QuadroIcms/QuadroIcms.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import ResultadoSt from "@/components/ResultadoSt/ResultadoSt.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "IcmsSt",

  mixins: [rotaBufferMixin, stringFormatMixin],

  props: {
    id: String | Number,
    buscarImposto: Function,
    tributoAtivo: String,
    exibeImposto: Boolean,
    limparImpostos: Boolean
    // dadosForm: Array | Object,
  },

  inject: ["alteracaoImportacao"],

  components: {
    BeneficiosIcms,
    FundoIcms,
    LoadingResultado,
    MensagemIcmsInterno,
    MensagemIpi,
    MensagemErro,
    QuadroComplementoIcms,
    QuadroIcms,
    QuadroPrincipal,
    PerguntasIcmsSt,
    ResultadoSt,
    QuadroAlerta,
    MultiplosSemResultado,
    ImpostoSemResultado
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "ICMS ST",
      ativarLoading: false,
      ativarLoadingSecundario: false,
      ativarLoadingTerciario: false,
      ativarLoadingQuaternario: false,
      beneficios: null,
      beneficioClasse: null,
      forceRerenderKeyBeneficios: 0,
      cargaTributariaEfetiva: 0,
      imposto: null,
      icms: null,
      icmsComplemento: [],
      nomeImposto: "icms_st",
      resultadoSt: null,
      segmentoSelecionado: {},
      icmsSelecionado: {},
      fundoSelecionado: {},
      complementoSelecionado: {},
      beneficioSelecionado: {},
      stSelecionado: {},
      mvaSelecionado: {},
      selecionouSegmento: false,
      selecionouIcms: false,
      selecionouFundo: false,
      selecionouComplemento: false,
      selecionouBeneficio: false,
      selecionouSt: false,
      selecionouMva: false,
      requerSegmento: true,
      requerIcms: true,
      requerFundo: true,
      requerComplemento: true,
      requerSt: true,
      requerMva: true,
      dadosForm: {},
      regra: 0,
      icmsAliquota: null,
      icmsAliquotaBackup: null,
      reduzAliquota: 0,
      erro: false,
      isencaoSt: {
        dados: [
          {
            label: "Inaplicabilidade da Substituição Tributária",
            texto_inaplicabilidade:
              "Não se aplica o regime de ICMS ST, caso a operação esteja sujeita a Isenção do ICMS.",
            id_imposto: 100
          }
        ]
      }
    };
  },

  created() {
    this.setSelecao({ selecao: { selecionouIcmsSt: this.selecionouIcmsSt }, id: this.id });
  },

  updated() {
    if (this.selecionouIcmsSt) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      // PUXA VALOR DE REGRA DO IPI QUANDO TROCA DE ABA
      this.regra = this.getDadosForm[this.id].regra;
      // PUXA VALOR DE ALÍQUOTA DO ICMS QUANDO TROCA DE ABA
      this.icmsAliquota = this.getDadosForm[this.id].aliquotaIcmsSelecionada;

      // VERIFICA SE HOUVE TROCA DE ALÍQUOTA DO ICMS INTERNO
      if (this.icmsAliquota != this.icmsAliquotaBackup) {
        this.imposto = null;
      }

      if (
        newValue == this.nomeImposto &&
        this.regra != 0 &&
        !this.imposto &&
        !this.ativarLoading &&
        this.icmsAliquota != null &&
        this.exibeImposto
      ) {
        this.edita();
        // ATUALIZA O BACKUP DA ALIQUOTA PARA FUTURAS VERIFICAÇÕES
        this.icmsAliquotaBackup = this.icmsAliquota;

        this.dadosForm = { ...this.getDadosForm[this.id] };
        this.ativarLoading = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
        this.ativarLoading = false;
      }
    },

    limparImpostos(newValue) {
      if (newValue) {
        this.imposto = null;
        this.edita();
      }
    },

    loading() {
      this.$emit("loading", this.loading);
    },

    selecionouIcmsSt() {
      this.setSelecao({ selecao: { selecionouIcmsSt: this.selecionouIcmsSt }, id: this.id });
    }
  },

  computed: {
    ...mapGetters("form", ["getDadosForm"]),
    ...mapGetters("reRender", ["getRenderKey"]),

    loading() {
      if (
        this.ativarLoading ||
        this.ativarLoadingSecundario ||
        this.ativarLoadingTerciario ||
        this.ativarLoadingQuaternario
      ) {
        return true;
      }
      return false;
    },

    regrasQuadroIcms: function() {
      return (
        !!this.imposto.icms &&
        !this.ativarLoadingSecundario &&
        this.selecionouSegmento &&
        this.segmentoSelecionado.valor_label != "NÃO"
      );
    },

    cargaEfetivaTributaria: function() {
      return (
        parseFloat(this.icmsSelecionado.aliquota) +
          parseFloat(this.complementoSelecionado.aliquota) || null
      );
    },

    aliquotaEfetivaSelecionada() {
      if (this.selecionouIcms && this.selecionouFundo) {
        // CÁLCULO DE ALÍQUOTA EFETIVA BASEADO NA REGRA DO FUNDO
        if (this.fundoSelecionado.regra_fundo == 2) {
          this.reduzAliquota = this.fundoSelecionado.aliquota;
          return Number(this.icmsSelecionado.aliquota);
        } else {
          this.reduzAliquota = 0;
          return Number(this.icmsSelecionado.aliquota) + Number(this.fundoSelecionado.aliquota);
        }
        // FIM
      }
      this.reduzAliquota = 0;
      return null;
    },
    regraComplemento() {
      if (
        !!this.imposto.complementoAliquota.length &&
        !this.ativarLoadingSecundario &&
        this.icmsSelecionado.label &&
        this.icmsSelecionado.label.toLowerCase().replaceAll(" ", "") != "alíquotaregrageral" &&
        this.segmentoSelecionado.valor_label != "NÃO" &&
        this.selecionouIcms
      ) {
        return true;
      }
      return false;
    },
    selecionouIcmsSt() {
      const selecionou = [
        this.selecionouSegmento,
        !this.requerIcms || this.selecionouIcms,
        !this.requerFundo || this.selecionouFundo,
        !this.requerComplemento || this.selecionouComplemento,
        !this.requerSt || this.selecionouSt,
        !this.requerMva || this.selecionouMva
      ];
      // DEBUG CONSOLE
      // console.log(selecionou);
      return !selecionou.filter(boolean => boolean == false).length;
    },

    impressaoLog() {
      let log = {
        logIcmsSt: {
          perguntas: this.segmentoSelecionado,
          icms: this.icmsSelecionado,
          fundo: this.fundoSelecionado,
          complemento: this.complementoSelecionado,
          beneficio: this.beneficioSelecionado,
          st: this.resultadoSt,
          mva: this.mvaSelecionado
        }
      };
      return log;
    }
  },

  methods: {
    ...mapActions("form", ["setDadosForm"]),
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    padronizaRequerimentosImpressao(boolean) {
      this.requerIcms = boolean;
      this.requerFundo = boolean;
      this.requerComplemento = boolean;
      this.requerSt = boolean;
      this.requerMva = boolean;
    },

    async seleciona(imposto) {
      this.segmentoSelecionado = imposto;
      this.selecionouSegmento = true;
      if (imposto.id_imposto == 100) {
        this.padronizaRequerimentosImpressao(false);
        return; //INAPLICABILIDADE
      }

      //AJUSTES PARA PAYLOAD
      this.dadosForm.valor_label_st = this.segmentoSelecionado.valor_label;
      if (this.segmentoSelecionado.valor_label == "NÃO") {
        this.dadosForm.st = -1;
      } else if (this.segmentoSelecionado.valor_label == "SIM") {
        this.dadosForm.st = 1;
      }
      this.dadosForm.id_cest = imposto.id_imposto;
      this.dadosForm.atribuicao = imposto.label_interestadual
        ? this.removerAcentos(imposto.label_interestadual)
        : null;
      this.dadosForm.id_icms = null;
      this.dadosForm.id_beneficio = null;
      //FIM

      //QUANDO A SUBSTITUICAO TRIBUTARIA FOR 'NAO' APENAS REPETE ALGUNS DADOS E EXIBE ALERTA DE CEST
      //FORMATACAO ABAIXO
      if (this.segmentoSelecionado.valor_label == "NÃO") {
        this.padronizaRequerimentosImpressao(false);
        const dados = {
          dados: [
            {
              label: "Contribuinte NÃO está na condição de Substituto Tributário:",
              ncm_convenio: this.segmentoSelecionado.ncm_convenio,
              descricao_convenio: this.segmentoSelecionado.descricao_convenio,
              label_pgdas: this.dadosForm.regimeRemetente == 32 ? "PGDAS-D" : null,
              valor_pgdas:
                "O substituto tributário do ICMS, optante pelo Simples Nacional, deverá recolher o ICMS sobre a operação própria na forma do Simples Nacional, segregando essa receita como “Sem substituição tributária/tributação monofásica/antecipação com encerramento de tributação (o substituto tributário do ICMS deve utilizar essa opção)”. Nesta hipótese, o aplicativo irá calcular o ICMS sobre a operação própria com base na receita informada (ICMS devido na forma do Simples Nacional).",
              alerta:
                "O CEST deverá ser indicado na nota fiscal, ainda que a operação não esteja sujeita ao regime de substituição tributária"
            }
          ]
        };
        this.resultadoSt = dados;
      }
      //FIM
    },

    async selecionaIcms(imposto) {
      this.icmsSelecionado = imposto;
      this.selecionouIcms = true;

      //PAYLOAD
      this.dadosForm.id_icms = imposto.id_tributacao;
      this.dadosForm.id_beneficio = null;
      //FIM

      // BUSCA RESULTADO PARA IMPOSTO DO ICMS ST
      if (!this.ativarLoadingTerciario) {
        this.ativarLoadingTerciario = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            this.resultadoSt = await this.chamadaRota("Cenario/obterImpostoIcmsSt", this.dadosForm);
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoadingTerciario = false;
            }
          }
        }
        this.ativarLoadingTerciario = false;
      }
      this.requerIcms = this.imposto ? !!this.imposto.icms.length : true;
      this.requerFundo = this.imposto ? !!this.imposto.fundo.dados.length : true;
      this.requerComplemento = this.imposto ? !!this.imposto.complementoAliquota.length : true;
      this.requerSt = this.resultadoSt ? !!this.resultadoSt.dados.length : true;

      // FIM
    },

    selecionaComplemento(imposto) {
      this.complementoSelecionado = imposto;
      this.selecionouComplemento = true;
    },

    selecionaFundo(imposto) {
      this.fundoSelecionado = imposto;
      this.selecionouFundo = true;
    },

    selecionaBeneficio(id) {
      this.resultadoSt = null;
      this.editaSt();
      this.beneficios = this.imposto.beneficios.map(beneficio => {
        if (beneficio.id_imposto == id) {
          this.beneficioSelecionado = beneficio.selecionado ? beneficio : {};
          this.selecionouBeneficio = beneficio.selecionado;
          this.beneficioClasse = beneficio.label;

          this.dadosForm.id_beneficio = this.selecionouBeneficio
            ? beneficio.id_tributacao_uf
              ? beneficio.id_tributacao_uf
              : beneficio.id_tributacao_geral
            : null;
        } else {
          beneficio.selecionado = false;
        }
        return beneficio;
      });

      this.forceRerenderKeyBeneficios += 1;

      //CHAMA OU NÃO O ST QUANDO SELECIONADO BENEFÍCIO
      this.chamadaBeneficio();
    },

    async chamadaBeneficio() {
      this.ativarLoadingQuaternario = true;
      if (this.selecionouBeneficio) {
        // CHAMA RESULTADO DO ST CASO NÃO SEJA BENEFÍCIO DE ISENÇÃO
        if (this.beneficioClasse != "Isenção" || !this.selecionouBeneficio) {
          let tentativas = 0;
          while (tentativas < 3) {
            try {
              this.resultadoSt = await this.chamadaRota(
                "Cenario/obterImpostoIcmsSt",
                this.dadosForm
              );
              tentativas = 3;
            } catch (error) {
              tentativas++;
              console.error(`${tentativas}ª tentativa`);
              if (tentativas === 3) {
                console.error(error);
                this.erro = true;
                this.ativarLoadingQuaternario = false;
              }
            }
          }
        } else {
          // SE FOR BENEFÍCIO DE ISENÇÃO MOSTRA ALERTA DO FRONT
          this.resultadoSt = this.isencaoSt;
        }
      } else {
        // REINICIA PAYLOAD
        this.dadosForm.id_beneficio = null;
        // FIM
        // EXIBE RESULTADO SEM BENEFÍCIO
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            this.resultadoSt = await this.chamadaRota("Cenario/obterImpostoIcmsSt", this.dadosForm);
            tentativas = 3;
          } catch (error) {
            console.error(error);
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              this.erro = true;
              this.ativarLoadingQuaternario = false;
            }
          }
        }
      }
      this.ativarLoadingQuaternario = false;
    },

    selecionaSt(imposto) {
      this.stSelecionado = imposto;
      this.selecionouSt = true;
      if (imposto.id_regra) {
        this.requerMva = !!this.resultadoSt.base.filter(regra => regra.id_regra == imposto.id_regra)
          .length;
      }
    },

    selecionaMva: function(mva) {
      this.mvaSelecionado = mva;
      this.selecionouMva = true;
    },

    edita() {
      this.segmentoSelecionado = {};
      this.selecionouSegmento = false;
      this.icms = null;

      this.editaIcms();
    },

    editaIcms() {
      this.icmsSelecionado = {};
      this.selecionouIcms = false;
      this.resultadoSt = null;
      this.beneficios = null;
      this.reduzAliquota = 0;
      this.padronizaRequerimentosImpressao(true);
      this.editaFundo();
      this.editaComplemento();
      this.editaBeneficios();
      this.editaSt();
      this.editaMva();
    },

    editaComplemento() {
      this.complementoSelecionado = {};
      this.selecionouComplemento = false;
    },

    editaFundo() {
      this.fundoSelecionado = null;
      this.selecionouFundo = false;
    },

    editaBeneficios() {
      this.beneficioSelecionado = {};
      this.selecionouBeneficio = false;
      this.resultadoSt = null;
      if (this.imposto && this.imposto.beneficios) {
        this.imposto.beneficios.map(beneficio => {
          beneficio.selecionado = false;
        });
      }
    },

    editaSt() {
      this.selecionouMva = false;
      this.stSelecionado = null;
      this.selecionouSt = false;
    },

    editaMva: function() {
      this.mvaSelecionado = {};
      this.selecionouMva = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
